import React from 'react';
import '../hojas-de-estilo/Pantalla.css';

const Pantalla = ({ input }) => (
  <div className='input'>
    {input}      
  </div>
); 

export default Pantalla;